"use client";

import { styled } from "styled-components";
import { LinkCard } from "@gnist/design-system";
import {
  TextSkeleton,
  RectangularSkeleton,
} from "@gnist/design-system/building-blocks/skeletons";
import { List, ListItem } from "@/components/carList/carList";
import { tokens } from "@gnist/themes/tokens.css.js";

const LoadingCard = styled(LinkCard)`
  background-color: ${tokens.color.surface};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-items: flex-start;
  row-gap: ${tokens.spacing.xs};
  padding: ${tokens.spacing.xs};
  > div {
    justify-content: flex-start;
  }
`;

interface LoadingCarListProps {
  count?: number;
}

export const LoadingCarList = ({ count = 9 }: LoadingCarListProps) => {
  return (
    <List>
      {Array.from({ length: count }, (_, i) => i).map((item) => (
        <ListItem key={item}>
          <LoadingCard>
            <LoadingContent>
              <RectangularSkeleton rounded />
              <TextSkeleton height="1.5em" width="100%" />
              <TextSkeleton height="1.5em" width="100%" />
              <TextSkeleton height="1.5em" width="80%" />
              <TextSkeleton height="1.5em" width="60%" />
              <TextSkeleton height="1.5em" width="50%" />
            </LoadingContent>
          </LoadingCard>
        </ListItem>
      ))}
    </List>
  );
};
